// Re-export all types through their domain-specific barrel files
export * from './api';
export * from './models';
export * from './services';

// Re-export all types through their domain-specific paths
export * from './api/common/http.types';
export * from './api/requests/auth.requests';
export * from './api/responses/auth.responses';
export * from './models/auth/auth.types';
export * from './services/core.types';

// Core type exports
export * from './api/common/http.types';
export * from './services/core.types';

// Auth-related types
export * from './models/auth/auth.types';
export * from './api/requests/auth.requests';
export * from './api/responses/auth.responses';

// Feature-specific types
export * from './app';
export * from './chat';
export * from './shared';

export * from './auth';
export * from './shared';

// Core API types
export type {
  HttpMethod,
  RequestConfig,
  ApiResponse,
  ErrorResponse,
  ApiConfig
} from './api/common/http.types';

// Auth types
export type {
  UserStatus,
  AuthStatus,
  User,
  AuthTokens,
  AuthSession,
  CognitoAttributes
} from './models/auth/auth.types';

export type {
  LoginCredentials,
  RegisterCredentials,
  ConfirmSignUpRequest,
  RefreshTokenRequest,
  ValidateSessionRequest
} from './api/requests/auth.requests';

export type {
  LoginResponse,
  RegisterResponse,
  ValidateSessionResponse,
  RefreshTokenResponse
} from './api/responses/auth.responses';

// Service types
export type {
  Interceptor,
  CacheConfig,
  CacheEntry,
  ServiceConfig
} from './services/core.types';

// Client types
export type { Client, AuthUser, FormAnswer } from './models/client.types';

// Feature-specific types
export * from './app';
export * from './chat';
export * from './shared'; 